import { FetchResult, MutationResult, useMutation } from '@apollo/client';
import {
	CampaignStatus,
	CreateSpotifyCampaignDocument,
	CreateSpotifyCampaignMutation,
} from 'wb-spotify/graphql/generated';
import {
	getSpotifyCampaignVariablesFromSupergridMutation,
	SpotifyMutationCampaign,
} from 'wb-spotify/app/routes/superGrid/mutator/hooks/utils';

const useCreateSpotifyCampaigns = (): [
	(campaignsInCreation: SpotifyMutationCampaign[], status: CampaignStatus) => Promise<FetchResult<CreateSpotifyCampaignMutation>>,
	MutationResult<CreateSpotifyCampaignMutation>,
] => {
	const [createSpotifyCampaigns, result] = useMutation(CreateSpotifyCampaignDocument, {
		errorPolicy: 'all',
	});

	const onCreateSpotifyCampaigns = async (
		campaignsInCreation: SpotifyMutationCampaign[],
		status: CampaignStatus,
	) => createSpotifyCampaigns({
		variables: {
			campaigns: campaignsInCreation.map((campaign) => getSpotifyCampaignVariablesFromSupergridMutation(campaign, status)),
		},
	});

	return [
		onCreateSpotifyCampaigns,
		result,
	];
};

export default useCreateSpotifyCampaigns;
